let _mailobfuscator = false;
window.mailobfuscator = {
  openMailto: function(address, subject = '', body = '') {
    let mailtoLink = `mailto:${encodeURIComponent(address)}`;
    const params = [];

    if (subject) params.push(`subject=${encodeURIComponent(subject)}`);
    if (body) params.push(`body=${encodeURIComponent(body)}`);

    if (params.length > 0) {
      mailtoLink += `?${params.join('&')}`;
    }

    // Simuliere Klick
    const a = document.createElement('a');
    a.href = mailtoLink;
    a.style.display = 'none';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  },

  init: function () {
    const emails = document.querySelectorAll('.m-contact__email a[data-mail]');

    for (const email of emails) {
      email.addEventListener('click', function(e) {
        e.stopPropagation()
        e.preventDefault()

        let emailadress = atob(e.target.getAttribute('data-mail'));


        window.mailobfuscator.openMailto(emailadress);

        return false;
      })
    }
  }
}

document.addEventListener("DOMContentLoaded", function () {
    if (_mailobfuscator) return;
  _mailobfuscator = true;
  window.mailobfuscator.init();
});
